
/**
 * Gera URL do QR Code
 */
export function getQRCodeUrl(data) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(data)}`
}

/**
 * Gera URL do WhatsApp
 */
export function getWhatsappUrl(number) {
  const cleanNumber = number.replace(/\D/g, '')
  return `https://wa.me/${cleanNumber}`
}

/**
 * Formata número de telefone brasileiro
 */
export function formatPhoneNumber(number) {
  const cleanNumber = number.replace(/\D/g, '')
  let maskedNumber = cleanNumber
  
  // Se começar com 55 (código do Brasil), remove
  if (cleanNumber.length > 2 && cleanNumber.startsWith('55')) {
    maskedNumber = cleanNumber.substring(2)
  }
  
  // Formatar como telefone brasileiro: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
  if (maskedNumber.length === 11) {
    // Celular: (XX) XXXXX-XXXX
    return `(${maskedNumber.substring(0, 2)}) ${maskedNumber.substring(2, 7)}-${maskedNumber.substring(7)}`
  } else if (maskedNumber.length === 10) {
    // Fixo: (XX) XXXX-XXXX
    return `(${maskedNumber.substring(0, 2)}) ${maskedNumber.substring(2, 6)}-${maskedNumber.substring(6)}`
  }
  
  return maskedNumber
}

/**
 * Copia texto para clipboard
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (err) {
    // Fallback para navegadores antigos
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      document.body.removeChild(textArea)
      return true
    } catch (err) {
      document.body.removeChild(textArea)
      return false
    }
  }
}

/**
 * Estados brasileiros
 */
export const ESTADOS = [
  { value: 'AC', label: 'AC' },
  { value: 'AL', label: 'AL' },
  { value: 'AP', label: 'AP' },
  { value: 'AM', label: 'AM' },
  { value: 'BA', label: 'BA' },
  { value: 'CE', label: 'CE' },
  { value: 'DF', label: 'DF' },
  { value: 'ES', label: 'ES' },
  { value: 'GO', label: 'GO' },
  { value: 'MA', label: 'MA' },
  { value: 'MT', label: 'MT' },
  { value: 'MS', label: 'MS' },
  { value: 'MG', label: 'MG' },
  { value: 'PA', label: 'PA' },
  { value: 'PB', label: 'PB' },
  { value: 'PR', label: 'PR' },
  { value: 'PE', label: 'PE' },
  { value: 'PI', label: 'PI' },
  { value: 'RJ', label: 'RJ' },
  { value: 'RN', label: 'RN' },
  { value: 'RS', label: 'RS' },
  { value: 'RO', label: 'RO' },
  { value: 'RR', label: 'RR' },
  { value: 'SC', label: 'SC' },
  { value: 'SP', label: 'SP' },
  { value: 'SE', label: 'SE' },
  { value: 'TO', label: 'TO' },
]
